<template>
    <div style="margin: 0px auto; width:72%;">
        <div class="center fs18 mb30" style="padding-top: 40px;">
            <p class="black fs32 fw500">{{ $t('account') }}</p>
            <span class="backyel dib divide"></span>
        </div>
        <div class="dflex showInLargef">
            <div style="width:30%;" class="dflex fc">
                <img v-if="!item['profile_image']" src="../assets/avatar.svg" alt="" width="100%">
                <img v-else :src="item['profile_image']" alt="" width="100%">
                <div class="center" style="margin-top:20px;height:30px;">
                    <a :class="$style.editbtn" @click="editAvatar" >{{$t('edit')}}</a>
                    <input style="display:none;" type="file" ref="avatar" @change="onAvatarEdit">
                </div>
            </div>
            <div style="width: 50%; padding-left: 10%;" class="fs26 dflex fc acsb">
                <div>
                    <p class="dflex mb30">
                        <span class="gray">{{ $t('un')}} :</span>
                        <uedit propName="user_name" :value="item['user_name']" @change="onEdit" class="f1 right"></uedit>
                    </p>
                    <p class="dflex mb30">
                        <span class="gray">{{ $t('phone1')}} : </span>
                        <uedit propName="mobile" :value="item['mobile']" @change="onEdit" class="f1 right"></uedit>
                    </p>
                    <p class="dflex mb30">
                        <span class="gray">{{ $t('email')}} : </span>
                        <uedit propName="email" :value="item['email']" @change="onEdit" class="f1 right"></uedit>
                    </p>
                    <p class="dflex">
                        <span class="gray">{{ $t('password')}} :</span>
                        <uedit propName="password" value="*******" @change="onEdit" class="f1 right"></uedit>
                    </p>
                </div>
            </div>
        </div>
        <div class="dflex fc showInSmallf">
            <div style="width:100%;margin-bottom: 30px;" class="dflex fc center">
                <img class="mcenter" v-if="!item['profile_image']" src="../assets/avatar.svg" alt="">
                <img class="mcenter" v-else :src="item['profile_image']" alt="">
                <div class="center" style="margin-top:20px;">
                    <a @click="editAvatar" :class="$style.editbtn">{{$t('edit')}}</a>
                    <input style="display:none;" type="file" ref="avatar" @change="onAvatarEdit">
                </div>
            </div>
            <div class="fs26 dflex fc acsb" style="margin-bottom: 30px;">
                <div>
                    <p class="dflex mb30">
                        <span class="gray">{{ $t('un')}} :</span>
                        <uedit propName="user_name" :value="item['user_name']" @change="onEdit" class="f1 right"></uedit>
                    </p>
                    <p class="dflex mb30">
                        <span class="gray">{{ $t('phone1')}} : </span>
                        <uedit propName="mobile" :value="item['mobile']" @change="onEdit" class="f1 right"></uedit>
                    </p>
                    <p class="dflex mb30">
                        <span class="gray">{{ $t('email')}} : </span>
                        <uedit propName="email" :value="item['email']" @change="onEdit" class="f1 right"></uedit>
                    </p>
                    <p class="dflex">
                        <span class="gray">{{ $t('password')}} :</span>
                        <uedit propName="password" value="*******" @change="onEdit" class="f1 right"></uedit>
                    </p>
                </div>
            </div>
        </div>
        <!-- <div v-if="contract.length > 0">
            <div class="center fs18 mb30" style="padding-top: 100px;">
                <p class="black fs32 fw500">{{ $t('contract') }}</p>
                <span class="backyel dib divide"></span>
            </div>
            <div class="dflex acsb fw">
                <div v-for="item in contract" :key="item.code" class='dflex' :class="$style.contract">
                    <img :src="item['head_portrait']" alt="" :class="$style.pic">
                    <div class="dflex fc" style="margin-left: 20px;">
                        <div class="f1">
                            <p class="gray">{{$t('code')}}:</p>
                            <p>{{item['helper_code']}}</p>
                        </div>
                        <div class="f1">
                            <p class="gray">{{$t('name')}}:</p>
                            <p>{{item['helper_name']}}</p>
                        </div>
                        <div class="f1">
                            <p class="gray">{{$t('contractp')}}:</p>
                            <p>{{item['start_at']}} - {{item['end_at']}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
		
		<div v-if="processList && processList.length > 0">
			<div class="center fs18 mb30" style="padding-top: 100px;">
			    <p class="black fs32 fw500">{{ $t('pname')}}</p>
			    <span class="backyel dib divide"></span>
			</div>
		    <el-table
		        :data="processList"
		        style="width: 100%">
		        <!-- <el-table-column
		            prop="order_number"
		            :label="$t('ol1')"
		            width="180">
		        </el-table-column> -->
		        
				<el-table-column
				    prop="pay_at"
				    :label="$t('process1')"
				    width="180">
				</el-table-column>
				<el-table-column
				    prop="helper_code"
				    :label="$t('process2')">
				</el-table-column>
				<el-table-column
				    prop="helper_name"
				    :label="$t('process3')">
				</el-table-column>
				<el-table-column
				    prop="typeStr"
				    :label="$t('process4')">
				</el-table-column>
		        <el-table-column
		            fixed="right"
		            :label="$t('process5')"
		            width="120">
		            <template slot-scope="scope">
		                <el-button
		                    @click.native.prevent="processDetail(scope.row)"
		                    type="text"
		                    size="small">
		                    detail
		                </el-button>
		            </template>
				</el-table-column>
		    </el-table>
		</div>
		
        <div v-if="orderList && orderList.length > 0">
			<div class="center fs18 mb30" style="padding-top: 100px;">
			    <p class="black fs32 fw500">{{ $t('contract') }}</p>
			    <span class="backyel dib divide"></span>
			</div>
            <el-table
                :data="orderList"
                style="width: 100%">
                <!-- <el-table-column
                    prop="order_number"
                    :label="$t('ol1')"
                    width="180">
                </el-table-column> -->
                <el-table-column
                    prop="typeStr"
                    :label="$t('ol2')"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="total_money"
                    :label="$t('ol3')">
                </el-table-column>
                <el-table-column
                    prop="created_at"
                    :label="$t('ol4')">
                </el-table-column>
                <el-table-column
                    prop="pay_at"
                    :label="$t('ol5')">
                </el-table-column>
                <el-table-column
                    fixed="right"
                    :label="$t('op')"
                    width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row['pay_status'] == 1">{{ $t('paid') }}</span>
                        <el-button v-else
                            @click.native.prevent="payOrder(scope.row)"
                            type="text"
                            size="small">
                            {{ $t('pay') }}
                        </el-button>
                    </template>
                    </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Person',
    data() {
        return {
            item: {
                user_name: '',
                emil: '',
                profile_image: '',
                mobile: '',
            },
            contract: [],
            mode: 'view',
            fileList: [],
            avatarErr: '',
            orderList: [],
			processList: [],
        };
    },
    created() {
        this.$service.my().then((res) => {
            this.item = res.data.user;
            this.contract = res.data.contract;
        });
        this.$service.getOrderList().then((res) => {
            res.data.list.forEach(item => {
                switch(item.type){
                    case 1:
                        item.typeStr = this.$t('p1');
                        break;
                    case 2:
                        item.typeStr = this.$t('pp2');
                        break;
                    case 3:
                        item.typeStr = this.$t('pp3');
                        break;
                    case 4:
                        item.typeStr = this.$t('p12');
                        break;
                    case 5:
                        item.typeStr = this.$t('p17');
                        break;
                    case 6:
                        item.typeStr = this.$t('p18');
                        break;
                }
            });
            this.orderList = res.data.list;
        });
		this.$service.getProcessList().then((res) => {
			res.data.list.forEach(item => {
			    switch(item.worker_type){
			        case 1:
			            item.typeStr = this.$t('p1');
			            break;
			        case 2:
			            item.typeStr = this.$t('pp2');
			            break;
			        case 3:
			            item.typeStr = this.$t('pp3');
			            break;
			        case 4:
			            item.typeStr = this.$t('p12');
			            break;
			        case 5:
			            item.typeStr = this.$t('p17');
			            break;
			        case 6:
			            item.typeStr = this.$t('p18');
			            break;
			    }
			});
			this.processList = res.data.list;
		});
    },
    methods: {
        onEdit(data) {
            const params = Object.assign({}, this.item, data.params);
            this.$service.editMy(data.params).then(() => {
                this.item = params;
                data.cb();
            }).catch((err) => {
                data.cb(err.message);
            });
        },
        editAvatar() {
            this.$refs.avatar.click();
        },
        onAvatarEdit(files) {
            this.avatarErr = '';
            const fileList = this.$refs.avatar.files;
            let reader = new FileReader();     //html5读文件
            reader.readAsDataURL(fileList[0]); //转BASE64
            reader.onload=(e) => {        //读取完毕后调用接口
                return this.$service.editMy({profile_image: e.target.result}).then((res)=>{
                    this.item['profile_image'] = e.target.result;
                    this.$forceUpdate();
                }).catch(() => {
                    this.avatarErr = 'upload avatar err';
                });
            };
        },
        payOrder(order) {
            if (order.type >= 5){
                this.$router.push('/renew/' + order.type + '/' + order['order_number']);
            } else {
                this.$router.push('/payment/' + order.type + '/' + order['order_number']);
            }
        },
		processDetail(detail) {
			this.$router.push('processdetail/' + detail.id);
		}
    }
}
</script>
<style module>
.contract {
    width: 45%;
    margin-bottom:50px;
}
.pic {
    width: 50%;
    height: 100%;
}
.editbtn {
    color: #f3b707e6;
    cursor: pointer;
    text-decoration: underline;
    transition:all .4s;
	-moz-transition:all .4s;
	-webkit-transition:all .4s;
	-o-transition:all .4s;
}
@media screen and (min-width: 770px) {
    .editbtn:hover {
        font-size: 20px;
    }
}
@media screen and (max-width: 770px) {
    .contract {
        width: 100%;
        margin-bottom:20px;
    }
    .pic {
        width:150px;
        height:180px;
    }
}
</style>
